<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Modules</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.appIdDesc }}</td>
          <td class="text-xs-left">{{ props.item.permitAgtRetrieveMth }}</td>
          <td class="text-xs-left">{{ props.item.permitAgtReviewDay }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptDelete(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Module<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="moduleDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newModule">
                  <v-text-field v-model="moduleForm.appId" :label="labels.appId" :error-messages="errors.collect('appId')" data-vv-name="appId" :data-vv-as="labels.appId" v-validate="'required|param|max:8'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.appId}}</v-subheader>
                  <div class="subheading">{{moduleForm.appId}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="moduleForm.appIdDesc" :label="labels.appIdDesc" :error-messages="errors.collect('appIdDesc')" v-validate="'required|entry|max:30'" data-vv-name="appIdDesc" :data-vv-as="labels.appIdDesc"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="moduleForm.permitAgtRetrieveMth" type="tel" :label="labels.permitAgtRetrieveMth" :error-messages="errors.collect('permitAgtRetrieveMth')" v-validate="'required|entry|max:255'" data-vv-name="permitAgtRetrieveMth" :data-vv-as="labels.permitAgtRetrieveMth"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="moduleForm.permitAgtReviewDay" type="tel" :label="labels.permitAgtReviewDay" :error-messages="errors.collect('permitAgtReviewDay')" v-validate="'required|entry|max:255'" data-vv-name="permitAgtReviewDay" :data-vv-as="labels.permitAgtRetrieveMth"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Application ID', value: 'appIdDesc' },
        { text: 'Permit Agent Retrieve Record(s) Month(s)', value: 'permitAgtRetrieveMth' },
        { text: 'Permit Agent Review Record(s) Day(s)', value: 'permitAgtReviewDay' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Modules Settings',
        appId: 'Application Id',
        appIdDesc: 'Application Id Description',
        permitAgtRetrieveMth: 'Permit Agent Retrieve Record(s) Month(s)',
        permitAgtReviewDay: 'Permit Agent Review Record(s) Day(s)'
      },
      moduleForm: {
        appId: null,
        appIdDesc: null,
        permitAgtRetrieveMth: null,
        permitAgtReviewDay: null
      },
      benType: [],
      moduleDialog: null,
      newModule: null,
      selectedId: {
        id: null,
        text: null
      },
      menu: {},
      filters: {},
      promptRemove: false
    }
  },
  computed: {
    general() {
      return this.$store.state.parameters.general
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiURI = this.general.menu.moduleList
      if (apiURI) {
        try {
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((moduleSetting) => {
              const convertObj = {
                appId: moduleSetting.appId,
                appIdDesc: moduleSetting.appId + ' - ' + moduleSetting.appIdDesc,
                permitAgtRetrieveMth: moduleSetting.permitAgtRetrieveMth,
                permitAgtReviewDay: moduleSetting.permitAgtReviewDay
              }
              this.items.push(convertObj)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('moduleInit')
      this.init()
    },
    async doReview(data) {
      this.moduleDialog = true
      const apiURI = this.general.menu.moduleGet
      const expand = {
        appId: data.item.appId
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.moduleForm.appId = data.module.appId
          this.moduleForm.appIdDesc = data.module.appIdDesc
          this.moduleForm.permitAgtRetrieveMth = data.module.permitAgtRetrieveMth
          this.moduleForm.permitAgtReviewDay = data.module.permitAgtReviewDay
          this.menu = extractMenu(result.data._links)
        }
        this.moduleDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newModule = true
      this.moduleDialog = true
    },
    doClose() {
      this.newModule = false
      this.moduleDialog = false
      this.moduleForm.appId = null
      this.moduleForm.appIdDesc = null
      this.moduleForm.permitAgtRetrieveMth = null
      this.moduleForm.permitAgtReviewDay = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newModule) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.general.menu.moduleCreate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.moduleForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.moduleUpdate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.moduleForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptDelete(moduleSetting) {
      this.resetMessages()
      this.selectedId.id = moduleSetting.appId
      this.selectedId.text = moduleSetting.appId + ' - ' + moduleSetting.appIdDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.general.menu.moduleDelete
      if (apiURI) {
        const expand = {
          appId: this.selectedId.id
        }
        this.$http.post(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
